import { ScrollTrigger } from "gsap/ScrollTrigger";

export const isDesktop =
  window.matchMedia("(pointer: fine)").matches ||
  ScrollTrigger.isTouch === 2 ||
  !/Android|webOS|iPhone|Mac OS|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
    navigator.userAgent
  ) ||
  (/Mac OS/i.test(navigator.userAgent) && !ScrollTrigger.isTouch);

// export const isDesktop = !ScrollTrigger.isTouch || ScrollTrigger.isTouch === 2;

export const desktopLottie = window.matchMedia("(min-width: 481px)").matches;
